import axios from "axios";
import FolderZipIcon from "@mui/icons-material/FolderZip";
import DownloadIcon from "@mui/icons-material/Download";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; 
export const getSharingLinkFromServer = async (studyId) => {
  try {
    const res = await axios.get(`${API_BASE_URL}/api/share-zip/${studyId}/`);
    return res.data;
  } catch (err) {
    return { success: false, error: "Server connection failed" };
  }
};


export const sendLinkToWhatsApp = (phoneNumber, zipUrl) => {
  const cleanPhone = phoneNumber.replace(/\D/g, ""); // Clean formatting safety
  const message = `📋 *DICOM Medical Study Archive*\n\nYou can access and download the full imaging series dataset using this secure cloud link:\n\n${zipUrl}\n\n_Note: This link will expire in 24 hours._`;
  
  window.open(
    `https://web.whatsapp.com/send?phone=${cleanPhone}&text=${encodeURIComponent(message)}`, 
    "_blank"
  );
};

export const DownloadZipToolConfig = (onDownloadZip) => ({
  name: "Download ZIP",
  tool: "DownloadZipTool",
  icon: <DownloadIcon />,
  customAction: () => {
    if (onDownloadZip) {
      onDownloadZip(); // This should ONLY run when clicked
    }
  },
});